import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getCountries() {
  const data = await apiGet('helper/countries');
  useHelperStore().setCountries(data);
}
